import { defineGameCard, onAppear } from '../authoring/index.js';
export const CoolingDroneCard = defineGameCard({
    id: 'cooling_drone',
    gameplay: {
        type: 'UNIT', cost: 2,
        baseStats: { attack: 1, health: 3 }, keywords: ['RUSH'],
    },
    presentation: {
        name: 'Охлаждающий дрон',
        description: 'Натиск. При появлении охладите на 1 другую союзную карту с наибольшим Перегревом.',
        glyph: {
            colors: ['#10213A', '#32405A', '#435572', '#5B7C9C', '#2E65B2'],
            rows: [
                '........1111........',
                '.1111..122221..1111.',
                '13333113333331123331',
                '13223222222222233221',
                '.122424444444424221.',
                '.123334411114332321.',
                '..1112344444332111..',
                '.....1111111111.....',
                '......13333321......',
                '......11111111......',
                '.......111111.......',
                '.........55.........',
                '........5555........',
                '.......555555.......',
                '......55555555......',
                '.....5555555555.....',
                '....555555555555....',
                '...5.5.5.55.5.5.5...',
                '..5.5.5.5..5.5.5.5..',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [onAppear((ctx) => {
            const self = ctx.self;
            const target = ctx.q.unitsOf(self.controllerId)
                .filter((unit) => unit.id !== self.id && unit.heat > 0)
                .sort((a, b) => b.heat - a.heat || a.seq - b.seq)[0];
            if (target !== undefined)
                ctx.ops.cool(target.id, 1);
        }, { cause: 'played' })],
    ui: { mechanics: ['rush', 'cool'] },
});
//# sourceMappingURL=cooling-drone.js.map